import { Spouse } from '../models/users/dto/spouse';
import { VariableBenefitAccountDetails } from '../models/transactions/variable-benefit-account-details';
import { AnnualMinimumProvenanceTypeIdEnum } from '../models/transactions/enum/annual-minimum-provenance-type-id.enum';
import { DateUtils } from './date-utils';

export class VbMinimumAgeUtils {
  static resolveMinimumAgeDateOfBirth(
    minimumAgeSpouseId: number | null | undefined,
    memberBirthDate: string,
    activeSpouse: Spouse | null | undefined
  ): string | null {
    if ((minimumAgeSpouseId ?? null) === null) return memberBirthDate;
    if (!!activeSpouse && minimumAgeSpouseId === activeSpouse.id) return activeSpouse.birthDate;
    return null;
  }

  static hasScheduledMinimumAgeChange(details: VariableBenefitAccountDetails | null | undefined): boolean {
    const next = details?.nextYearAnnualMinimumDetails;
    if (!next) return false;
    const currentSpouseId = details?.currentYearAnnualMinimumDetails?.minimumAgeSpouseId ?? null;
    return (next.minimumAgeSpouseId ?? null) !== currentSpouseId;
  }

  static minimumAgeChangeEffectiveYear(details: VariableBenefitAccountDetails): number {
    const next = details.nextYearAnnualMinimumDetails;
    if (next?.provenanceTypeId === AnnualMinimumProvenanceTypeIdEnum.Actual) return next.effectiveYear + 1;
    return DateUtils.currentYearInCST() + 1;
  }
}
